var _defs, _style, _g, _g2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEscudosAlto(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 74 52",
    width: 74,
    height: 52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "escudos_alto-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(35.45,0,0,38.47,18.94,26.81)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8c79f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b8b8ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(26.94,-26.94,26.921,26.921,23.19,34.69)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0e9621"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#128933"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g3",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-1.34,-33.36,30.58,-1.228,37.43,33.56)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#98cb32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#769f25"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g4",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(23.12,0,0,21.017,27.09,26.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6af1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d19317"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\t.s0 { fill: none;stroke: #0c973c;stroke-miterlimit:10;stroke-width: .5 } \r\n\t\t.s1 { fill: url(#g1) } \r\n\t\t.s2 { fill: url(#g2) } \r\n\t\t.s3 { fill: #ffffff } \r\n\t\t.s4 { opacity: .8;fill: url(#g3) } \r\n\t\t.s5 { fill: #fcee3d;stroke: url(#g4);stroke-miterlimit:10;stroke-width: .4 } \r\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m20.7 24.9h-5.7l-2.6-6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m23.1 30h-11.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m17.3 27.5h4.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m11.6 19c-1.2 0-2.2-0.9-2.2-2.1 0-1.2 1-2.2 2.2-2.2 1.1 0 2.1 1 2.1 2.2 0 1.2-1 2.1-2.1 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m9.9 32.2c-1.2 0-2.2-1-2.2-2.2 0-1.2 1-2.1 2.2-2.1 1.1 0 2.1 0.9 2.1 2.1 0 1.2-1 2.2-2.1 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m16.3 28.5c-0.5 0-1-0.5-1-1 0-0.6 0.5-1 1-1 0.5 0 1 0.4 1 1 0 0.5-0.5 1-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m18.7 34l4.7-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m24.9 34.5l-6.8 3.8v4.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m17.6 35.5c-0.7 0-1.2-0.5-1.2-1.2 0-0.6 0.5-1.2 1.2-1.2 0.6 0 1.2 0.6 1.2 1.2 0 0.7-0.6 1.2-1.2 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m18.1 46.9c-1.2 0-2.2-0.9-2.2-2.1 0-1.2 1-2.2 2.1-2.2 1.2 0 2.2 1 2.2 2.2 0 1.2-1 2.1-2.2 2.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m52 24.6h6.7l2.6-6.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m50.9 29.7h10.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m56.4 27.1h-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m62.1 18.7c-1.2 0-2.1-1-2.1-2.2 0-1.2 0.9-2.1 2.1-2.1 1.2 0 2.2 0.9 2.2 2.1 0 1.2-1 2.2-2.2 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m63.8 31.8c-1.2 0-2.2-0.9-2.2-2.1 0-1.2 1-2.2 2.2-2.2 1.2 0 2.2 1 2.2 2.2 0 1.2-1 2.1-2.2 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m57.4 28.1c-0.6 0-1-0.4-1-1 0-0.5 0.4-1 1-1 0.5 0 0.9 0.5 0.9 1 0 0.6-0.4 1-0.9 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m54.9 33.6l-4.8-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m49 34l6.6 4v4.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m56.1 35.2c-0.7 0-1.2-0.6-1.2-1.2 0-0.7 0.5-1.2 1.2-1.2 0.6 0 1.2 0.5 1.2 1.2 0 0.6-0.6 1.2-1.2 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m55.6 46.6c-1.2 0-2.1-1-2.1-2.2 0-1.2 0.9-2.1 2.1-2.1 1.2 0 2.2 0.9 2.2 2.1 0 1.2-1 2.2-2.2 2.2z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m36.7 46c-0.9 0-1.7-0.2-2.3-0.7-5.1-3.8-9-8.4-11.6-13.8-2.6-5.4-3.9-11.4-3.9-17.9 0-1.2 0.6-2.2 1.4-3 0.7-0.5 1.6-0.8 2.4-0.8 0.3 0 0.6 0 1 0.1 0.9 0.2 2.1 0.4 3.6 0.4q4.1 0 7.3-2.1c0.6-0.4 1.3-0.6 2-0.6h0.1c0.7 0 1.4 0.2 2 0.6 2.2 1.4 4.6 2.1 7.3 2.1 1.5 0 2.7-0.2 3.5-0.4 0.5-0.1 0.8-0.1 1.1-0.1 0.9 0 1.7 0.3 2.4 0.8 0.9 0.8 1.4 1.8 1.4 3 0 6.4-1.2 12.3-3.8 17.6-2.6 5.5-6.5 10.2-11.7 14.1-0.6 0.5-1.4 0.8-2.2 0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m36.7 46c-0.9 0-1.7-0.2-2.3-0.7-5.1-3.8-9-8.4-11.6-13.8-2.6-5.4-3.9-11.4-3.9-17.9 0-1.2 0.6-2.2 1.4-3 0.7-0.5 1.6-0.8 2.4-0.8 0.3 0 0.6 0 1 0.1 0.9 0.2 2.1 0.4 3.6 0.4q4.1 0 7.3-2.1c0.6-0.4 1.3-0.6 2-0.6h0.1c0.7 0 1.4 0.2 2 0.6 2.2 1.4 4.6 2.1 7.3 2.1 1.5 0 2.7-0.2 3.5-0.4 0.5-0.1 0.8-0.1 1.1-0.1 0.9 0 1.7 0.3 2.4 0.8 0.9 0.8 1.4 1.8 1.4 3 0 6.4-1.2 12.3-3.8 17.6-2.6 5.5-6.5 10.2-11.7 14.1-0.6 0.5-1.4 0.8-2.2 0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m36.7 44.6c-0.7 0-1.3-0.2-1.8-0.5-4.8-3.6-8.4-8-10.9-13.1-2.5-5.1-3.7-10.8-3.7-17 0-0.9 0.4-1.7 1.1-2.2 0.5-0.4 1.1-0.7 1.8-0.7q0.3 0 0.8 0.1c0.8 0.2 2.1 0.4 3.6 0.4q4.2 0 7.5-2.1 0.7-0.5 1.5-0.5h0.1q0.8 0 1.5 0.5c2.2 1.4 4.7 2.1 7.5 2.1 1.5 0 2.7-0.2 3.5-0.4 0.4 0 0.7-0.1 0.9-0.1 0.7 0 1.3 0.2 1.8 0.7 0.7 0.5 1.1 1.3 1.1 2.2 0.1 6.1-1.1 11.7-3.5 16.8-2.5 5.1-6.2 9.6-11.1 13.2-0.5 0.4-1.1 0.6-1.7 0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m36.7 44.3q-0.9 0-1.6-0.5c-4.7-3.6-8.4-7.9-10.8-13-2.5-5-3.7-10.7-3.6-16.8 0-0.8 0.3-1.5 0.9-2 0.5-0.3 1-0.5 1.6-0.5q0.3 0 0.8 0.1c0.8 0.1 2.1 0.3 3.6 0.3 2.9 0 5.5-0.7 7.7-2.2q0.6-0.4 1.4-0.4 0.7 0 1.4 0.4c2.2 1.5 4.8 2.2 7.6 2.2 1.5 0 2.7-0.2 3.6-0.3q0.6-0.1 0.8-0.1c0.6 0 1.2 0.2 1.6 0.5 0.6 0.5 1 1.3 1 2 0 6.1-1.2 11.7-3.5 16.6-2.5 5.1-6.2 9.5-11 13.2q-0.7 0.5-1.5 0.5z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m50.1 15.9c-0.1-0.1-0.2-0.1-0.3-0.1q-0.7 0.3-1.4 0.7-0.6 0.4-1.3 0.8-1.2 0.8-2.4 1.7-1.1 0.9-2.2 1.9-1 1-2 2.1-1 1-1.9 2.1-1 1-1.8 2.1l-1.3 1.6q0 0-0.1-0.1-0.1-0.2-0.2-0.4l-0.3-0.4q-0.2-0.4-0.5-0.7-0.3-0.4-0.6-0.7-0.2-0.4-0.6-0.7-0.1-0.2-0.3-0.4-0.1-0.1-0.3-0.3-0.3-0.4-0.6-0.7-0.3-0.3-0.7-0.6-0.3-0.3-0.7-0.7l-0.3-0.3q-0.2-0.1-0.4-0.3-0.4-0.3-0.8-0.6-0.3-0.2-0.7-0.5-0.4-0.3-0.9-0.5-0.1-0.1-0.2 0c-0.1 0-0.1 0.1-0.1 0.2q0.2 0.4 0.4 0.8 0.2 0.4 0.3 0.7 0.2 0.4 0.4 0.8 0.2 0.4 0.4 0.8 0.2 0.3 0.4 0.7 0.2 0.4 0.4 0.8l0.2 0.3 0.2 0.4q0.2 0.4 0.4 0.7l1.5 3 0.3 0.7q0.1 0.2 0.2 0.4 0.1 0.1 0.2 0.3l0.8 1.4 1.9 3.7 1.7-3.5 0.3-0.6 0.3-0.6q0.3-0.6 0.6-1.1 0.3-0.6 0.6-1.2 0.3-0.6 0.7-1.1 0.7-1.2 1.4-2.3 0.8-1.1 1.6-2.2 0.4-0.5 0.8-1 0.4-0.6 0.8-1.1 0.9-1.1 1.8-2.1 0.5-0.5 1-1 0.5-0.5 1-0.9 0.5-0.5 1.1-1 0.5-0.4 1.1-0.8 0.1-0.1 0-0.2z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEscudosAlto);
export default __webpack_public_path__ + "static/media/escudos_alto.b115e6cdc9c1680bd4d60f049f6a51bd.svg";
export { ForwardRef as ReactComponent };